<template>
    <div v-if="show && loaded" class="nevs-popup-container">
        <div class="nevs-popup smtp-send-popup">
            <div class="nevs-popup-text">
                <NevsTextField v-model="data.recipients" :label="$LANG.Get('fields.emailRecipients') + ':'"></NevsTextField>
                <NevsTextField v-model="data.cc" :label="$LANG.Get('fields.emailCc') + ':'"></NevsTextField>
                <NevsTextField v-model="data.bcc" :label="$LANG.Get('fields.emailBcc') + ':'"></NevsTextField>
                <div class="smtp-disclaimer">{{ $LANG.Get('labels.smtpAddressSeparatorNote') }}</div>
                <NevsTextField v-model="data.subject" :label="$LANG.Get('fields.emailSubject') + ':'"></NevsTextField>
                <NevsTextArea v-model="data.body" :label="$LANG.Get('fields.emailBody') + ':'"></NevsTextArea>
                <div class="attachment-section">
                    <div v-for="(attachment, index) in data.attachments" :key="index" class="attachment-row">
                        <NevsUpload v-model="data.attachments[index]"></NevsUpload>
                        <span class="attachment-remove" @click="removeAttachment(index)"><i class="fa-solid fa-trash"></i></span>
                    </div>
                    <NevsButton @click="addAttachment()">
                        <i class="fa-solid fa-paperclip"></i>
                        {{ $LANG.Get('buttons.addAttachment') }}
                    </NevsButton>
                </div>
                <div class="smtp-disclaimer">
                    <i class="fa-solid fa-circle-info"></i>
                    {{ $LANG.Get('labels.smtpEmailDisclaimer') }}
                </div>
            </div>
            <div class="nevs-popup-buttons">
                <NevsButton class="error" @click="cancelClick()">{{ $LANG.Get('buttons.cancel') }}</NevsButton>
                <NevsButton class="success" @click="sendClick()">{{ $LANG.Get('buttons.send') }}</NevsButton>
            </div>
        </div>
    </div>
</template>

<script>
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsTextArea from "@/components/nevs/NevsTextArea.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";
import NevsUpload from "@/components/nevs/NevsUpload.vue";

export default {
    name: "ModalSendEmailSmtp",
    components: {NevsUpload, NevsTextArea, NevsTextField, NevsButton},
    props: {
        show: {
            type: Boolean,
            default: false
        },
        documentId: {
            type: Number,
            default: null
        },
        customerId: {
            type: Number,
            default: null
        },
        endpoint: {
            type: String,
            default: ''
        },
        defaultSubject: {
            type: String,
            default: ''
        },
        defaultBody: {
            type: String,
            default: ''
        }
    },
    emits: ['done'],
    data() {
        return {
            loaded: false,
            data: {
                recipients: '',
                cc: '',
                bcc: '',
                subject: '',
                body: '',
                attachments: []
            }
        }
    },
    watch: {
        show() {
            this.loaded = false;
            this.data.recipients = '';
            this.data.cc = this.$store.state.user.client.email_copy ?? '';
            this.data.bcc = '';
            this.data.subject = this.defaultSubject;
            this.data.body = this.defaultBody;
            this.data.attachments = [];

            if (this.show) {
                if (this.customerId !== null) {
                    let vm = this;
                    this.$API.APICall('get', 'customers/' + this.customerId, {}, (data, success) => {
                        if (success && data.customer !== null) {
                            let emails = data.customer.emails
                                .filter(e => e.documents)
                                .map(e => e.address);
                            vm.data.recipients = emails.join(';');
                        }
                        vm.loaded = true;
                    });
                } else {
                    this.loaded = true;
                }
            }
        }
    },
    methods: {
        addAttachment() {
            this.data.attachments.push({id: 0, name: '', link: ''});
        },
        removeAttachment(index) {
            this.data.attachments.splice(index, 1);
        },
        cancelClick() {
            this.$emit('done', false);
        },
        sendClick() {
            let vm = this;
            let recipientList = this.data.recipients.split(';').map(e => e.trim()).filter(e => e !== '');
            let ccList = this.data.cc.split(';').map(e => e.trim()).filter(e => e !== '');
            let bccList = this.data.bcc.split(';').map(e => e.trim()).filter(e => e !== '');
            let attachmentIds = this.data.attachments.filter(a => a.id > 0).map(a => a.id);

            this.$API.APICall('post', this.endpoint + '/email/' + this.documentId, {
                recipients: recipientList,
                cc: ccList,
                bcc: bccList,
                subject: this.data.subject,
                body: this.data.body,
                attachment_ids: attachmentIds
            }, (data, success) => {
                if (success) {
                    vm.$LOCAL_BUS.TriggerEvent('popup', {text: vm.$LANG.Get('alerts.emailSent'), type: 'alert'});
                    vm.$emit('done', true);
                } else if (data && data.smtp_error) {
                    vm.$LOCAL_BUS.TriggerEvent('popup', {text: data.smtp_error, type: 'alert'});
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        }
    }
}
</script>

<style scoped>
.smtp-send-popup {
    width: 500px;
}

.attachment-section {
    margin-top: 8px;
}

.attachment-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 4px;
}

.attachment-remove {
    cursor: pointer;
    color: #e74c3c;
    padding: 4px;
}

.smtp-disclaimer {
    margin-top: 10px;
    font-size: 0.85em;
    opacity: 0.7;
}
</style>
